import React from 'react';
import UserDetailsCard from '../../User/UserDetailsCard';

export default function UserProfilePage() {
	return (
		<div>
			<UserDetailsCard />
		</div>
	);
}
